import { siteConfig } from '@/config/site';

/** Площадка, отзыв на которой засчитывается в акции «Вы нам отзыв, мы вам ролл». */
export interface ReviewPlatform {
  key: 'yandex' | 'gis' | 'vk';
  name: string;
  /** Короткий знак площадки на кнопке. */
  mark: string;
  url: string;
}

// Порядок и состав — как в условиях акции: по роллу за отзыв на каждой площадке.
const PLATFORMS = [
  { key: 'yandex', name: 'Яндекс Карты', mark: 'Я', setting: 'links.review_yandex' },
  { key: 'gis', name: '2ГИС', mark: '2ГИС', setting: 'links.review_2gis' },
  { key: 'vk', name: 'ВКонтакте', mark: 'VK', setting: 'links.review_vk' },
] as const;

function httpsUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const text = value.trim();
  try {
    return new URL(text).protocol === 'https:' ? text : null;
  } catch {
    return null;
  }
}

/**
 * Собирает кнопки площадок из публичных настроек сайта (GET /content/settings).
 *
 * Ссылки владелец правит в админке. Если настройки не ответили или в поле не
 * ссылка, остаётся запасной адрес из конфига: кнопка, которая никуда не ведёт,
 * хуже кнопки со вчерашним адресом.
 */
export function reviewPlatforms(settings: unknown): ReviewPlatform[] {
  const values =
    typeof settings === 'object' && settings !== null ? (settings as Record<string, unknown>) : {};
  return PLATFORMS.map(({ key, name, mark, setting }) => ({
    key,
    name,
    mark,
    url: httpsUrl(values[setting]) ?? siteConfig.links.reviews[key],
  }));
}
